export default "__VITE_ASSET__D8ZR8JoT__"